<style lang="scss" scoped>
a.nav-link.active:hover,
a.nav-link.active:focus {
  color: #fff;
}

a.nav-link {
  cursor: pointer;
}

li.nav-item.disabled,
.nav-link.disabled {
  cursor: not-allowed;
}

li.nav-item {
  width: 50%;
}

li.nav-item:focus {
  outline: none;
}

.payment-method {
  cursor: pointer;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 100ms ease-in;
  width: 150px;
  height: 105px;
  margin: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  appearance: none;

  filter: grayscale(1) opacity(0.7);

  &:hover {
    filter: grayscale(0.5) opacity(0.9);
  }

  &:focus {
    filter: grayscale(0.5) opacity(0.9);
    outline: none;
  }

  &:active {
    opacity: 0.9;
  }

  &.checked {
    filter: none;
    transform: scale(1.2);
  }
}

.paypal {
  background-image: url("../images/payment/paypal.png");
}

.creditcard,
.creditcard-micropayment {
  background-image: url("../images/payment/cc.png");
}

.klarna {
  background-image: url("https://www.micropayment.de/resources/?what=img&group=klarna-sofort&show=type-c.1");
}

.prepaid {
  background-image: url("../images/payment/prepaid.jpg");
}

.paysafecard {
  background-image: url("../images/payment/paysafecard.jpg");
}

.coupon {
  background-image: url("../images/payment/gutschein.png");
}

.call2pay {
  background-image: url("../images/payment/call2pay.png");
}

.handypay {
  background-image: url("../images/payment/handypay.png");
}

@media (max-width: 700px) {
  .nav-link.text-xl {
    font-size: 1.4rem;
  }
  .text-xl {
    font-size: 1.4rem;
  }
}

@media (max-width: 490px) {
  .nav-link.text-xl {
    font-size: 0.9rem;
  }
}
</style>

<template>
  <div class="card">
    <div class="card-header bg-primary text-white">
      <small
        >Nichts was auf der Welt gut ist, ist kostenlos. Es gibt natürlich
        Portale und Communitys die kostenlos sind und Ihre Einnahmen durch den
        Verkauf von persönlichen Daten gewährleisten. Da wir dies ablehnen,
        verlangen wir eine kleine Gebühr. Dadurch bleiben zusätzlich Spammer und
        Spinner draußen. Hier bist du und deine Daten sicher! Jede
        Bezahlmethoden ist diskret und verschlüsselt – ohne Abo’s. Nach jedem
        (erfolgreichen) Zahlvorgang werden dir die {{ appCurrency }} direkt
        gutgeschrieben. Manchmal kann dies etwas länger dauern. Habe daher bitte
        etwas Geduld, falls es doch ein paar Minuten dauern sollte.</small
      >
    </div>
    <div class="card-header text-center">
      <h2 class="card-title">{{ appCurrency }} kaufen</h2>
      <ul role="tablist" class="nav nav-pills">
        <li @click="setStep(0)" role="tab" tabindex="0" class="nav-item">
          <a
            data-toggle="tab"
            :class="{ active: step == 0 }"
            class="nav-link text-xl"
          >
            <span>
              Zahlungsmethoden wählen
            </span>
          </a>
        </li>
        <li @click="setStep(1)" role="tab" tabindex="1" class="nav-item">
          <a
            data-toggle="tab"
            :class="{ active: step == 1 }"
            class="nav-link text-xl"
          >
            <span> Menge an {{ appCurrency }} wählen </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content">
        <div
          role="tabpanel"
          :class="{ active: step == 0, show: step == 0 }"
          class="tab-pane fade"
        >
          <div class="p-md-5">
            <div class="pb-2 d-flex flex-wrap justify-content-around">
              <p class="text-center text-xl">
                Wählen Sie ihre gewünschte Zahlungsmethode aus
              </p>
            </div>
            <div class="pb-5 d-flex flex-wrap justify-content-around">
              <div v-for="(service, name) in getServices()" :key="name">
                <div
                  :class="['payment-method', name, { checked: method == name }]"
                  @click="choseMethod(name)"
                ></div>
              </div>
            </div>
            <div class="float-right">
              <button
                @click="setStep(1)"
                type="button"
                :class="{ disabled: !method }"
                class="btn btn-next btn-wd btn-primary text-xl"
              >
                weiter
              </button>
            </div>
          </div>
        </div>
        <div
          v-if="step == 1"
          role="tabpanel"
          :class="{ active: step == 1, show: step == 1 }"
          class="tab-pane fade"
        >
          <component
            :minAmount="minAmount"
            :maxAmount="maxAmount"
            :suggestedAmount="suggestedAmount"
            :key="method"
            :service="services[method]"
            :name="method"
            @buy="buy"
            @back="setStep(0)"
            :is="getComponent(services[method]['type'])"
          >
          </component>
        </div>
      </div>
    </div>
    <prepaid-modal></prepaid-modal>
    <complete-profile-modal></complete-profile-modal>
  </div>
</template>

<script>
import { CSRFToken } from "@/communication";
import PaymentSlider from "@/components/payment/PaymentSlider";
import PaymentPackage from "@/components/payment/PaymentPackage";
import PaymentCode from "@/components/payment/PaymentCode";
import PrepaidModal from "@/components/payment/PrepaidModal";
import CompleteProfileModal from "@/components/modals/CompleteProfileModal";

/**
 * sends a request to the specified url from a form. this will change the window location.
 * @param {string} path the path to send the post request to
 * @param {object} params the paramiters to add to the url
 * @param {string} [method=post] the method to use on the form
 */

function post(path, params, method) {
  method = method || "post"; // Set method to post by default if not specified.

  // The rest of this code assumes you are not using a library.
  // It can be made less wordy if you use one.
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}

export default {
  components: {
    PrepaidModal,
    PaymentSlider,
    PaymentPackage,
    PaymentCode,
    CompleteProfileModal
  },
  props: {
    services: Object,
    methods: Array,
    flatFee: Number,
    minAmount: Number,
    maxAmount: Number,
    suggestedAmount: Number
  },
  data() {
    return {
      method: "",
      step: 0
    };
  },
  computed: {
    appCurrency() {
      return Laravel.lang.currency;
    },
    customerProfileId() {
      return Laravel.user.customer_profile.id;
    },
    prepaidPrefix() {
      let prefix = Laravel.payment.prepaid.prefix;
      return prefix == null || prefix == "" ? null : prefix;
    },
    allowedPaymentMethods() {
      return Laravel.user.allowed_payment_methods;
    }
  },
  methods: {
    choseMethod(method) {
      this.method = method;
      this.setStep(1);
    },
    setStep(step) {
      if (this.method && Laravel.user.customer_profile.zipcode) {
        this.step = step;
      }
      if (!Laravel.user.customer_profile.zipcode) {
        this.$modal.show("complete-profile");
      }
    },
    getServices() {
      let services = {};
      for (let service in this.services) {
        if (
          this.allowedPaymentMethods[service] &&
          this.methods.includes(service)
        ) {
          services[service] = this.services[service];
        }
      }

      return services;
    },
    getComponent(type) {
      return "Payment" + type.charAt(0).toUpperCase() + type.slice(1);
    },
    getServicesOfTypes(types) {
      let services = {};

      for (let service in this.services) {
        if (
          types.includes(this.services[service].type) &&
          this.allowedPaymentMethods[service] &&
          this.methods.includes(service)
        ) {
          services[service] = this.services[service];
        }
      }

      return services;
    },
    buy({ method, price, coins }) {
      if (method === "creditcard") {
        this.buyWithStripe(price, coins);
      }
      if (method === "creditcard-micropayment") {
        this.buyWithMicropaymentCreditCard(price, coins);
      }
      if (method === "paypal") {
        this.buyWithPaypal(price);
      }
      if (method === "klarna") {
        this.buyWithKlarna(price);
      }
      if (method === "paysafecard") {
        this.buyWithPaysafecard(price);
      }
      if (method === "call2pay") {
        this.buyWithCall2Pay(price);
      }
      if (method === "handypay") {
        this.buyWithHandypay(price);
      }
      if (method === "prepaid") {
        this.buyPrepaid(price);
      }
    },
    buyWithHandypay(price) {
      window.location = `${
        Laravel.payment.micropayment.handypay_url
      }&amount=${this.getCentPrice(price)}&customer=${this.customerProfileId}`;
    },
    buyWithMicropaymentCreditCard(price) {
      window.location = `${
        Laravel.payment.micropayment.creditcard_url
      }&amount=${this.getCentPrice(price)}&customer=${this.customerProfileId}`;
    },
    buyWithCall2Pay(price) {
      window.location = `${
        Laravel.payment.micropayment.call2pay_url
      }&amount=${this.getCentPrice(price)}&customer=${this.customerProfileId}`;
    },
    buyWithPaysafecard(price) {
      window.location = `${
        Laravel.payment.micropayment.paysafecard_url
      }&amount=${this.getCentPrice(price)}&customer=${this.customerProfileId}`;
    },
    buyWithKlarna(price) {
      window.location = `${
        Laravel.payment.micropayment.sofort_url
      }&amount=${this.getCentPrice(price)}&customer=${this.customerProfileId}`;
    },
    buyWithPaypal(price) {
      post("/api/v1/payment/paypal", {
        price: price,
        _token: CSRFToken()
      });
    },
    buyWithStripe(price) {
      this.$http
        .post("/api/v1/payment/stripe", {
          price: this.getCentPrice(price)
        })
        .then(response => {
          let stripe = Stripe(Laravel.payment.stripe.publicKey);
          stripe
            .redirectToCheckout({
              sessionId: response.data
            })
            .then(function(result) {
              console.log(result.error.message);
            });
        });
    },
    async buyPrepaid(price) {
      const {
        data: { customer_profile_id, id }
      } = await this.$http.post("/api/v1/payment/prepaid", {
        price: this.getCentPrice(price)
      });

      this.$modal.show("prepaid", {
        price: price,
        transactionId: id,
        transferDescription:
          (this.prepaidPrefix !== null ? this.prepaidPrefix + "-" : "") +
          `${customer_profile_id}-${id}`
      });
    },
    getCentPrice(price) {
      return Math.round(price * 100);
    }
  }
};
</script>
